import { render, staticRenderFns } from "./SliderCaptcha.vue?vue&type=template&id=72f3e49a&scoped=true"
import script from "./SliderCaptcha.vue?vue&type=script&lang=js"
export * from "./SliderCaptcha.vue?vue&type=script&lang=js"
import style0 from "./SliderCaptcha.vue?vue&type=style&index=0&id=72f3e49a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f3e49a",
  null
  
)

export default component.exports